export function OutlineSlidersHorizontalIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00037 14.0501C6.10582 14.0501 7.00196 13.1539 7.00196 12.0485C7.00196 10.943 6.10582 10.0469 5.00037 10.0469C3.89492 10.0469 2.99878 10.943 2.99878 12.0485C2.99878 13.1539 3.89492 14.0501 5.00037 14.0501Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99731 12H20.9989"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M17.0004 7.00318C18.1058 7.00318 19.002 6.10704 19.002 5.00159C19.002 3.89614 18.1058 3 17.0004 3C15.8949 3 14.9988 3.89614 14.9988 5.00159C14.9988 6.10704 15.8949 7.00318 17.0004 7.00318Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99878 5.00195H14.9987"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M18.9971 5.00195H20.9987"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M11.9987 20.9993C13.1041 20.9993 14.0003 20.1031 14.0003 18.9977C14.0003 17.8922 13.1041 16.9961 11.9987 16.9961C10.8932 16.9961 9.99707 17.8922 9.99707 18.9977C9.99707 20.1031 10.8932 20.9993 11.9987 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0002 18.9512H20.9986"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M2.99878 18.9512H9.99715"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
